import { render, staticRenderFns } from "./LandingLink.vue?vue&type=template&id=9c1a7720"
import script from "./LandingLink.vue?vue&type=script&lang=js"
export * from "./LandingLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports